import { render } from "./add-key.vue?vue&type=template&id=619f6b12&ts=true"
import script from "./add-key.vue?vue&type=script&lang=ts"
export * from "./add-key.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/ops/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__